import React from 'react'
import styled from 'styled-components'

type StarsProps = {
  value: number
  total?: number
  className?: string
  onValueChanged?: (value: number) => void
}

const Stars: React.FunctionComponent<StarsProps> = ({ value, total, className, onValueChanged }) => {
    if (total == null) {
        total = 5
    }

    const selectImage = (index: number) => {
        if (index + 1 <= value) {
            return require('./images/full_star.svg')
        }

        if (index + 0.5 <= value) {
            return require('./images/half_star.svg')
        }

        return require('./images/empty_star.svg')
    }

    const starClicked = (index: number) => {
        // If we clicked on the star representing the current value,
        // we need to inverse the half
        if (value === index + 1) {
            onValueChanged && onValueChanged(value - 0.5)
            return
        } else if (value === index + 0.5) {
            onValueChanged && onValueChanged(value + 0.5)
            return
        }

        // otherwise just set the value
        onValueChanged && onValueChanged(index + 1)
    }

    return (
        <Container className={className}>
            {
                (new Array(total).fill(undefined).map((_, index) => <StarIcon key={index} src={selectImage(index)} onClick={() => starClicked(index)}/>))
            }
        </Container>
    )
}

const Container = styled.div`
  height: 100%;
`

const StarIcon = styled.img`
    aspect-ratio: 1 / 1;
    height: 100%;
`

export default Stars